var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "page-outline",
    {
      attrs: {
        title: _vm.$t(
          "Webheader.connector_list_" +
            _vm.entitiesType +
            "_" +
            _vm.role +
            "_" +
            _vm.type
        ),
      },
    },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-container",
            { staticClass: "listPage", attrs: { fluid: "" } },
            [
              _c(
                "b-row",
                { staticClass: "justify-content-start" },
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "mb-5",
                      attrs: { cols: "4", sm: "3", md: "2", xl: "2" },
                    },
                    [
                      _c("back-button", {
                        attrs: { returnUrl: _vm.returnUrl },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    {
                      staticClass: "mb-5",
                      attrs: { cols: "4", sm: "3", md: "2", xl: "2" },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "btnFilter",
                          attrs: { disabled: _vm.activateSpinner },
                          on: {
                            click: function ($event) {
                              return _vm.onRefresh()
                            },
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "fa-light fa-rotate-right fs-14px",
                          }),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("common.rfrsh")) +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "justify-content-start" },
                [
                  _vm.canGetVopProvider && _vm.entitiesType == "rvm"
                    ? _c(
                        "b-col",
                        { attrs: { cols: "6", lg: "3", xl: "3" } },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass:
                                "mr-3 justify-item-end responsive-button",
                              attrs: { variant: "primary" },
                              on: { click: _vm.getVopProvider },
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "common.routing.consult_list_vop_provider"
                                    )
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c(
                "b-tabs",
                {
                  attrs: {
                    value: _vm.role == 0 ? 1 : 0,
                    "nav-class": "d-none",
                  },
                },
                [
                  _c(
                    "b-tab",
                    {
                      class: _vm.role == 0 ? "d-none" : "",
                      attrs: { title: _vm.$t("common.routing.receiver") },
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-tabs",
                            {
                              staticClass: "p-3 w-100",
                              attrs: { "content-class": "mt-3" },
                              model: {
                                value: _vm.tabIndex,
                                callback: function ($$v) {
                                  _vm.tabIndex = $$v
                                },
                                expression: "tabIndex",
                              },
                            },
                            [
                              _c(
                                "b-tab",
                                { attrs: { title: "WebService" } },
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { md: "12" } },
                                    [
                                      _vm.activateSpinner
                                        ? _c("spinner")
                                        : _c(
                                            "div",
                                            [
                                              _vm.webServiceCredentialList
                                                .length > 0
                                                ? _c("b-table", {
                                                    staticClass:
                                                      "mt-3 table-striped",
                                                    attrs: {
                                                      hover: "",
                                                      responsive: "",
                                                      items:
                                                        _vm.webServiceCredentialList,
                                                      fields:
                                                        _vm.webServiceCredentialFields,
                                                      selectable: "",
                                                      "select-mode": "single",
                                                    },
                                                    on: {
                                                      "row-selected":
                                                        _vm.seeWebServiceCredentialDetails,
                                                    },
                                                  })
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex justify-content-center",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "noResult",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                      " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "common.no_result"
                                                                )
                                                              ) +
                                                              "\n                    "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                            ],
                                            1
                                          ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-tab",
                                { attrs: { title: "MqSeries" } },
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { md: "12" } },
                                    [
                                      _vm.activateSpinner
                                        ? _c("spinner")
                                        : _c(
                                            "div",
                                            [
                                              _vm.mqseriesCredentialList
                                                .length > 0
                                                ? _c("b-table", {
                                                    staticClass:
                                                      "mt-3 table-striped",
                                                    attrs: {
                                                      hover: "",
                                                      responsive: "",
                                                      items:
                                                        _vm.mqseriesCredentialList,
                                                      fields:
                                                        _vm.mqseriesCredentialFields,
                                                      selectable: "",
                                                      "select-mode": "single",
                                                    },
                                                    on: {
                                                      "row-selected":
                                                        _vm.seeMQSeriesCredentialDetails,
                                                    },
                                                  })
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex justify-content-center",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "noResult",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "common.no_result"
                                                                )
                                                              ) +
                                                              "\n                      "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                            ],
                                            1
                                          ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-tab",
                                {
                                  attrs: {
                                    title: _vm.$t("common.routing.ftp"),
                                  },
                                },
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { md: "12" } },
                                    [
                                      _vm.activateSpinner
                                        ? _c("spinner")
                                        : _c(
                                            "div",
                                            [
                                              _vm.FTPCredentialList.length > 0
                                                ? _c("b-table", {
                                                    staticClass:
                                                      "mt-3 table-striped",
                                                    attrs: {
                                                      hover: "",
                                                      responsive: "",
                                                      items:
                                                        _vm.FTPCredentialList,
                                                      fields: _vm.FTPFields,
                                                      selectable: "",
                                                      "select-mode": "single",
                                                    },
                                                    on: {
                                                      "row-selected":
                                                        _vm.seeFTPCredentialDetails,
                                                    },
                                                  })
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex justify-content-center",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "noResult",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "common.no_result"
                                                                )
                                                              ) +
                                                              "\n                      "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                            ],
                                            1
                                          ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-tab",
                    {
                      class: _vm.role == 1 ? "d-none" : "",
                      attrs: { title: _vm.$t("common.routing.responder") },
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-tabs",
                            {
                              staticClass: "p-3 w-100",
                              attrs: { "content-class": "mt-3" },
                              model: {
                                value: _vm.tabIndex,
                                callback: function ($$v) {
                                  _vm.tabIndex = $$v
                                },
                                expression: "tabIndex",
                              },
                            },
                            [
                              _c(
                                "b-tab",
                                { attrs: { title: "WebService" } },
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { md: "12" } },
                                    [
                                      _vm.activateSpinner
                                        ? _c("spinner")
                                        : _c(
                                            "div",
                                            [
                                              _vm.webServiceConfigList.length >
                                              0
                                                ? _c("b-table", {
                                                    staticClass:
                                                      "mt-3 table-striped",
                                                    attrs: {
                                                      hover: "",
                                                      responsive: "",
                                                      items:
                                                        _vm.webServiceConfigList,
                                                      fields:
                                                        _vm.webServiceConfigFields,
                                                      selectable: "",
                                                      "select-mode": "single",
                                                    },
                                                    on: {
                                                      "row-selected":
                                                        _vm.seeWebServiceConfigDetails,
                                                    },
                                                  })
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex justify-content-center",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "noResult",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                      " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "common.no_result"
                                                                )
                                                              ) +
                                                              "\n                    "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                            ],
                                            1
                                          ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-tab",
                                { attrs: { title: "MqSeries" } },
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { md: "12" } },
                                    [
                                      _vm.activateSpinner
                                        ? _c("spinner")
                                        : _c(
                                            "div",
                                            [
                                              _vm.mqseriesConfigList.length > 0
                                                ? _c("b-table", {
                                                    staticClass:
                                                      "mt-3 table-striped table-hover",
                                                    attrs: {
                                                      hover: "",
                                                      responsive: "",
                                                      items:
                                                        _vm.mqseriesConfigList,
                                                      fields:
                                                        _vm.mqseriesFields,
                                                      selectable: "",
                                                      "select-mode": "single",
                                                    },
                                                    on: {
                                                      "row-selected":
                                                        _vm.seeMQSeriesDetails,
                                                    },
                                                  })
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex justify-content-center",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "noResult",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "common.no_result"
                                                                )
                                                              ) +
                                                              "\n                      "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                            ],
                                            1
                                          ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-tab",
                                {
                                  attrs: {
                                    title: _vm.$t("common.routing.ftp"),
                                  },
                                },
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { md: "12" } },
                                    [
                                      _vm.activateSpinner
                                        ? _c("spinner")
                                        : _c(
                                            "div",
                                            [
                                              _vm.FTPConfigList.length > 0
                                                ? _c("b-table", {
                                                    staticClass:
                                                      "mt-3 table-striped",
                                                    attrs: {
                                                      hover: "",
                                                      responsive: "",
                                                      items: _vm.FTPConfigList,
                                                      fields: _vm.FTPFields,
                                                      selectable: "",
                                                      "select-mode": "single",
                                                    },
                                                    on: {
                                                      "row-selected":
                                                        _vm.seeFTPConfigDetails,
                                                    },
                                                  })
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex justify-content-center",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "noResult",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "common.no_result"
                                                                )
                                                              ) +
                                                              "\n                      "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                            ],
                                            1
                                          ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.configType !== "INTERPROCESS" && _vm.canAddConfig
                ? _c(
                    "b-row",
                    { staticClass: "justify-content-end mt-3 no-gutters" },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "primary" },
                          on: { click: _vm.addConfig },
                        },
                        [
                          _c("i", { staticClass: "fa-light fa-plus fs-17px" }),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("common.routing.add_config"))),
                          ]),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }